
































































import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import SecondaryButton from '../buttons/SecondaryButton.vue';
import CloseIcon from '../../../assets/img/close.svg';
import { Document } from '@/store/types';
import Vue from 'vue';
import DocumentViewWithProgress from '@/components/common/DocumentViewWithProgress.vue';
import axios from '@/utils/axios';
import { mapActions as mapRootActions } from 'vuex';
export default Vue.extend({
    components: { DocumentViewWithProgress, SecondaryButton, CloseIcon },
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        uploadUrl: {
            type: String,
            required: true,
        },
        value: {
            type: Array as () => Document[],
            default: () => [],
        },
    },
    data: function() {
        return {
            id: uuidv4(),
            files: this.value,
            domFiles: '',
            drag: false,
            uploadProgress: {} as { [key: string]: number },
        };
    },
    watch: {
        value() {
            this.files = this.value;
        },
    },
    methods: {
        ...mapRootActions(['addError']),
        fileChange(files: FileList) {
            this.domFiles = '';
            this.saveFiles(files);
            this.drag = false;
        },
        remove(file: File) {
            const index = _.findIndex(this.files, f => f.id === file.name);
            if (!_.isNil(index)) {
                this.files.splice(index, 1);
            }
            this.domFiles = '';
            this.$emit('input', this.files);
        },
        async saveFiles(files: FileList) {
            this.$emit('uploading', true);
            // temporary assignment during upload
            const uploadedFiles = this.files.slice();
            const filesToUpload: Document[] = [];
            const requests = _.compact(
                Array.from<File>(files).map((file: File) => {
                    if (file.size === 0 || _.isEmpty(file.name)) {
                        return null;
                    }
                    const id = uuidv4();
                    filesToUpload.push({
                        id,
                        name: file.name,
                        size: file.size,
                        type: _.last(file.name?.split('.')) ?? '',
                    });
                    const formData = new FormData();
                    formData.append('file', file);
                    return axios.post(this.uploadUrl, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        onUploadProgress: progressEvent => {
                            const total = progressEvent.total || progressEvent.loaded;
                            const percentCompleted = Math.floor((progressEvent.loaded * 100) / total);
                            this.uploadProgress = { ...this.uploadProgress, [id]: percentCompleted };
                        },
                    });
                }),
            );
            this.files = filesToUpload.concat(this.files);
            try {
                const responses = await Promise.all(requests);
                this.files = responses
                    .map(({ data }, index) => {
                        if (data.success) {
                            return {
                                id: data.data.id,
                                name: data.data.name,
                                type: data.data.id.slice(data.data.id.lastIndexOf('.') + 1),
                                size: data.data.size,
                                error: undefined,
                            };
                        } else {
                            this.addError({ ...data, error: new Error(data) });
                            return {
                                ...this.files[index],
                                error: data.message ?? data.errorMsg ?? 'Upload failed.',
                            };
                        }
                    })
                    .filter(file => !file.error)
                    .concat(uploadedFiles);
                this.$emit('input', this.files);
            } catch (e) {
                this.$emit('error', e);
            } finally {
                this.$emit('uploading', false);
            }
        },
    },
});
